import { createSlice } from '@reduxjs/toolkit';
import { arrayWrap } from '@jamesgmarks/utilities';
import { IPromotedListingSegmentTimeline, IPromotedListingsState } from './interfaces';
import { IPromotedListingContract } from '../../../entity-interfaces/IPromotedListingContractPricing';
import { ELoadState, IActionType } from '../../utils';

const initialState:IPromotedListingsState = {
  loadedState: 'idle',
  segmentTimeline: [],
  contracts: [],
  contractsLoadedState: ELoadState.idle,
};
export const promotedListingsSlice = createSlice({
  name: 'promotedListings',
  initialState,
  reducers: {
    timelineReceived: (state, action: IActionType<IPromotedListingSegmentTimeline[]>) => {
      state.segmentTimeline = arrayWrap(action.payload);
    },
    setLoadedState: (state, action: { type: string, payload: string }) => {
      state.loadedState = action.payload;
    },
    contractsReceived: (state, action: IActionType<IPromotedListingContract[]>) => {
      state.contracts = arrayWrap(action.payload);
    },
    setContractsLoadedState: (state, action: IActionType<ELoadState>) => {
      state.contractsLoadedState = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  contractsReceived,
  setContractsLoadedState,
  timelineReceived,
  setLoadedState,
} = promotedListingsSlice.actions;

export default promotedListingsSlice.reducer;
